<template>
    <div class="not-logged-notification">
        <span class="icon-info"></span>
        <span v-if="isFreeOrPromotional" v-html="$t('CourseOverview.notes_non_logged_in_free')"></span>
        <span v-else v-html="$t('CourseOverview.notes_non_logged_in')"></span>
    </div>
</template>

<script>
    export default {
        name: 'CourseOverviewNotLoggedNotification',
        props: {
            course: Object
        },
        computed: {
            isFreeOrPromotional () {
                return this.course.free === true || this.course.promotional === true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .not-logged-notification {
            margin: 20px 0 0;
            background: $amber;
            padding: 10px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            font-size: 1.4rem;
            line-height: 150%;

            .icon-info {
                margin: 0 10px 0 0;
                font-size: 2rem;
            }
        }
</style>